<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="template-edit-container" *ngIf="!loading; else loadingTpl">
  <div class="template-edit-header">
    <h2>{{isNew ? 'New Task Template' : 'Edit Task Template'}}</h2>
    <small style="color:#888">isTemplate = true — templates are blueprints that materialize into real tasks.</small>
  </div>

  <form [formGroup]="form">

    <!-- HEADER SECTION -->
    <p-fieldset legend="Header" styleClass="template-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label>Name <span class="required">*</span></label>
          <input pInputText formControlName="name" type="text"
            [class.ng-invalid]="isFieldInvalid('name')" />
          <small class="p-error" *ngIf="isFieldInvalid('name')">Name is required.</small>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label>Description</label>
          <textarea pInputTextarea formControlName="description" rows="2"></textarea>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Est. Hours to Complete</label>
          <p-inputNumber formControlName="hoursEstToComplete" [minFractionDigits]="1" [maxFractionDigits]="2" [min]="0"></p-inputNumber>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Priority Tier</label>
          <p-dropdown [options]="priorityOptions" formControlName="priorityTier"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Region</label>
          <p-dropdown [options]="regionOptions" formControlName="region"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label>Billable Entity</label>
          <p-dropdown [options]="billableOptions" formControlName="billableEntity"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
        </div>
        <div class="p-field p-col-12 p-md-3" style="padding-top:1.5rem">
          <p-checkbox formControlName="requiresEmptyUnit" [binary]="true" label="Requires Empty Unit"></p-checkbox>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Assigned Team (default)</label>
          <p-dropdown [options]="[{label: '— None —', value: null}, ...teams.map(t => ({label: t.name, value: t.taskTeamId}))]"
            formControlName="assignedToTeamId"
            optionLabel="label" optionValue="value" appendTo="body"
            placeholder="Select team...">
          </p-dropdown>
          <small>Team pre-assigned when this template materializes into a task.</small>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Default Vendor</label>
          <p-dropdown [options]="[{label: '— None —', value: null}, ...filteredVendors().map(v => ({label: v.name, value: v.vendorId}))]"
            formControlName="assignedToVendorId"
            optionLabel="label" optionValue="value" appendTo="body"
            placeholder="Select vendor...">
          </p-dropdown>
          <small>Filtered by Region when a team is selected.</small>
        </div>
      </div>
    </p-fieldset>

    <!-- TRIGGER SECTION -->
    <p-fieldset legend="Trigger" styleClass="template-section">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
          <label>Trigger Type</label>
          <p-dropdown [options]="triggerOptions" formControlName="triggerType"
            optionLabel="label" optionValue="value" appendTo="body">
          </p-dropdown>
          <small>Stored in int_1 slot</small>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label>Trigger Param 1 (int_2)</label>
          <input pInputText formControlName="triggerParam1" type="number" />
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label>Trigger Param 2 (int_3)</label>
          <input pInputText formControlName="triggerParam2" type="number" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label>Trigger Param String (str_1)</label>
          <input pInputText formControlName="triggerParamString" type="text" />
        </div>
      </div>
    </p-fieldset>

    <!-- LINE ITEMS SECTION -->
    <p-fieldset legend="Line Items" styleClass="template-section">
      <p-table [value]="lineItemsArray.controls" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th style="width:120px">Line Type</th>
            <th style="width:220px">Product</th>
            <th style="width:200px">Description</th>
            <th style="width:80px">Qty</th>
            <th style="width:90px">Unit Cost</th>
            <th style="width:90px">Total</th>
            <th style="width:80px">Bill Owner</th>
            <th style="width:130px">Supply Source</th>
            <th style="width:70px">Required</th>
            <th style="width:50px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ctrl let-i="rowIndex">
          <tr [formGroup]="ctrl">
            <td>
              <p-dropdown [options]="lineTypeOptions" formControlName="lineType"
                optionLabel="label" optionValue="value" appendTo="body"
                styleClass="li-dd">
              </p-dropdown>
            </td>
            <td>
              <p-autoComplete formControlName="orderProductName"
                [suggestions]="productSuggestions"
                (completeMethod)="searchProducts($event)"
                (onSelect)="onProductSelect($event, i)"
                field="name"
                appendTo="body"
                styleClass="li-ac"
                placeholder="Search product...">
              </p-autoComplete>
            </td>
            <td>
              <input pInputText formControlName="description" type="text" style="width:100%" />
            </td>
            <td>
              <p-inputNumber formControlName="qty" [minFractionDigits]="0" [maxFractionDigits]="3" [min]="0" inputStyleClass="li-num"></p-inputNumber>
            </td>
            <td>
              <p-inputNumber formControlName="unitCost" mode="currency" currency="USD" locale="en-US" [min]="0" inputStyleClass="li-num"></p-inputNumber>
            </td>
            <td style="text-align:right; font-weight:600">
              {{getLineItemTotal(i) | currency:'USD'}}
            </td>
            <td style="text-align:center">
              <p-checkbox formControlName="billableToOwner" [binary]="true"></p-checkbox>
            </td>
            <td>
              <p-dropdown [options]="[{label:'—', value: null}, ...supplySourceOptions]" formControlName="supplySource"
                optionLabel="label" optionValue="value" appendTo="body"
                styleClass="li-dd">
              </p-dropdown>
            </td>
            <td style="text-align:center">
              <p-checkbox formControlName="isRequired" [binary]="true"></p-checkbox>
            </td>
            <td>
              <button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm"
                (click)="removeLineItem(i)">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10" style="text-align:center; padding:1rem; color:#888">No line items yet.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="5" style="text-align:right; font-weight:600; padding-right:0.5rem">Running Total:</td>
            <td style="text-align:right; font-weight:700">{{lineItemsRunningTotal | currency:'USD'}}</td>
            <td colspan="4"></td>
          </tr>
        </ng-template>
      </p-table>
      <div style="margin-top:0.75rem">
        <button pButton pRipple class="p-button-outlined p-button-secondary p-button-sm"
          label="Add Line Item" icon="pi pi-plus"
          (click)="addLineItemRow()">
        </button>
      </div>
    </p-fieldset>

    <!-- REQUIREMENTS SECTION -->
    <p-fieldset legend="Requirements / Checklist" styleClass="template-section">
      <p-table [value]="requirementsArray.controls" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th style="width:200px">Name</th>
            <th style="width:120px">Category</th>
            <th>Description</th>
            <th style="width:80px">Photo Req</th>
            <th style="width:80px">Note Req</th>
            <th style="width:80px">Required</th>
            <th style="width:50px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ctrl let-i="rowIndex">
          <tr [formGroup]="ctrl">
            <td>
              <input pInputText formControlName="name" type="text" style="width:100%"
                [class.ng-invalid]="ctrl.get('name').invalid && ctrl.get('name').touched" />
            </td>
            <td>
              <input pInputText formControlName="category" type="text" style="width:100%" placeholder="Bathroom, Kitchen..." />
            </td>
            <td>
              <input pInputText formControlName="description" type="text" style="width:100%" />
            </td>
            <td style="text-align:center">
              <p-checkbox formControlName="requiresPhoto" [binary]="true"></p-checkbox>
            </td>
            <td style="text-align:center">
              <p-checkbox formControlName="requiresNote" [binary]="true"></p-checkbox>
            </td>
            <td style="text-align:center">
              <p-checkbox formControlName="isRequired" [binary]="true"></p-checkbox>
            </td>
            <td>
              <button pButton pRipple icon="pi pi-trash" class="p-button-text p-button-danger p-button-sm"
                (click)="removeRequirement(i)">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:center; padding:1rem; color:#888">No checklist requirements yet.</td>
          </tr>
        </ng-template>
      </p-table>
      <div style="margin-top:0.75rem">
        <button pButton pRipple class="p-button-outlined p-button-secondary p-button-sm"
          label="Add Requirement" icon="pi pi-plus"
          (click)="addRequirementRow()">
        </button>
      </div>
    </p-fieldset>

  </form>
</div>

<ng-template #loadingTpl>
  <div style="text-align:center; padding:3rem;">
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>

<!-- Sticky footer -->
<div class="template-edit-footer">
  <button pButton pRipple class="p-button-secondary p-button-outlined"
    label="Cancel" (click)="onCancel()">
  </button>
  <button pButton pRipple class="p-button btn-blue"
    label="Save" [loading]="saving" (click)="onSave()"
    [disabled]="saving">
  </button>
</div>
